import { IState } from "../interfaces";
import React from "react";
import ReactHookz from "../../../ReactHookz/index";
import actions from "./actions";
import { translations } from "../translations";

const initialState: IState = {
  language: "nl",
  country: "BE",
  translations: translations["nl"],
};

export const useReactHookz = ReactHookz(React, initialState, actions);
